import PropTypes from 'prop-types';
import { Typography, Box, Accordion, AccordionSummary } from '@mui/material';
import { ArrowDownward } from '@mui/icons-material';
import PictureUploader from '../../reuseable-components/PictureUploader/PictureUploader';

ProductPictureUploader.propTypes = {
  formValue: PropTypes.object,
  setFormValue: PropTypes.func,
}

export default function ProductPictureUploader({ formValue, setFormValue }) {

  return <Box sx={{ border: "solid thin rgb(43 45 47 / 24%)" }}>
    <Accordion>
      <AccordionSummary expandIcon={<ArrowDownward />}>
        <Typography component="span">Pictures ({formValue.pictures?.length ?? 0})</Typography>
      </AccordionSummary>
      <Box sx={{ mx: 2, mb: 2 }}>
        <PictureUploader pictures={formValue.pictures ?? []}
          removePicture={(picture) => setFormValue(form => {
            form.pictures = form.pictures.filter(pic => pic !== picture);
            return { ...form };
          })}
          addPicture={(picture) => setFormValue(form => {
            form.pictures = [...(form.pictures ?? []), picture];
            return { ...form };
          })} />
      </Box>
    </Accordion>
  </Box>;
}
